import GetWidgetClassNativeLanguageLookupRequestModelBase from '../_generated/modelBases/get-widget-class-native-language-lookup-request-model-base';

export default class GetWidgetClassNativeLanguageLookupRequestModel extends GetWidgetClassNativeLanguageLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
